import ComingSoon from 'components/ComingSoon';

export const Events = () => (
  <ComingSoon text="Here you'll find all your events, online meetings, and conferences. Also, this section will display third parties' invitations to join events. " />
);
